import React from 'react';

const CardSkeleton = ({ height = '200px' }) => {
  return (
    <div className="card shadow-sm border-0 rounded-3" style={{ height }}>
      <div className="card-body d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mt-2 mb-0">Loading...</p>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;